
// keyrequired = true if compulsory field
// type is what type of field is required, Available options are
// supportedTypes = [
//   "input"            // Input field
//   "textarea",        // Text Area
//   "auto-complete",   // input with dropdown 
//   "select-dropdown", // Input with Dropdown but also add and edit function for options
//   "checkbox",        // checkbox input
//   "radio",           // radio button group
//   "group",           // group of children (nested items)
//   "br",              // line break
//   "hr"               // horizontal line
//   "date"             // Single Date picker
//   "tabs"             // For 
// ];
// options send json as given in eg
// Header = label , Placeholder for input fields
// id as in input is to just catch items value for their designated select ,input,textarea in cases of mutiple
// As of right now i am pushing all outputs into the form with id as key and value as value in a FORM
// checkValidation is sent an input when submitting the form, Its to check if any required field is empty at form submission, send send checkRequired value in it
// ShowAdd:true,
// ShowEdit="true" incase to show the edit button in select-dropdown, default value false
// populateFromApi is just a check to confirm if to populate options from API
// To create a group of items, type = group, header if any, class = 'col' 1-12, and inside children put the json of the item wanted in group
// type hr for line
// For type:'tabs', active:num (Which key is default active),tabs:[id:num (id number for tab),title:string (for the tab name), children:[{} (same json for items)]]
// api:{url:string (apiURLName), params:{} (if any)} set the api name here to call data from it. 
// idSelect key is when whats to be shown, and whats to be sent to backend are different, in this case, name key of option is shown and id key is sent when selected
// readonly true if input field is only read only
// 


export const addSiteJson=[
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'short_code',
    header: 'Site Code',
    placeholder: 'Select Code',
    keyRequired: true,
    checkValidation: false,
    populateFromApi: false,
    // readonly:true,
  },
  {
    type: 'input',
    class: 'col-12 col-sm-6 col-md-9 col-lg-9 col-xl-9',
    id: 'name',
    header: 'Site Name',
    placeholder: 'Enter Site Name',
    keyRequired: true,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'country',
    header: 'Country',
    placeholder: 'Country',
    keyRequired: true,
    checkValidation: false,
    populateFromApi: false,
    options:[]
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'state',
    header: 'State',
    placeholder: 'State',
    keyRequired: true,
    checkValidation: false,
    populateFromApi: false,
    showEdit: false,
    options:[]
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'city',
    header: 'City',
    placeholder: 'City',
    keyRequired: true,
    checkValidation: false,
    populateFromApi: true,
    showEdit: false,
    options:[]
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'zipcode',
    header: 'Zip Code',
    placeholder: 'Enter Code',
    keyRequired: true,
    checkValidation: false
  },
  {
    type: 'textarea',
    class: 'col-12',
    id: 'address',
    header: 'Address',
    placeholder: 'Enter Full Address',
    keyRequired: true,
    checkValidation: false
  },
  {
    type:'hr'
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'site_group',
    header: 'Parent Organization',
    placeholder: 'Enter Parent Organization',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'facility_name',
    header: 'Facility Co. Name',
    placeholder: 'Enter Co. Name',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'currency',
    header: 'Currency',
    placeholder: 'Enter Currency',
    keyRequired: false,
    checkValidation: false,
    readonly:true
  },
  {
    type: 'select-dropdown',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'application',
    header: 'Application',
    placeholder: 'Select Application',
    keyRequired: true,
    checkValidation: false,
    populateFromApi: true,
    showEdit:true,
    ShowAdd:true,
    api: { url: 'Application', params: {} }
  },
  {
    type: 'select-dropdown',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'type',
    header: 'Type',
    placeholder: 'Select Type',
    keyRequired: false,
    checkValidation: false,
    populateFromApi: true,
    api: { url: 'Processor', params: {} }
  },
  {
    type: 'select-dropdown',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'project_id',
    header: 'Site Solution Type',
    placeholder: 'Select Solution',
    keyRequired: true,
    checkValidation: false,
    populateFromApi: true,
    api: { url: 'SiteSolutionType', params: {} }
  },
  {
    type: 'select-dropdown',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'communication',
    header: 'Communication',
    placeholder: 'Select Communication',
    keyRequired: true,
    checkValidation: false,
    populateFromApi: true,
    api: { url: 'Communications', params: {} }
  },
  {
    type: 'group',
    header: 'Select Payment Gateways',
    class: 'col-12 col-sm-6 col-md-9 col-lg-9 col-xl-9',
    children: [
      {
        type: 'radio',
        class: 'col-12',
        id: 'pg_enable',
        header: '',
        keyRequired: true,
        checkValidation: false,
        options: [
          { id: 'Y', name: 'Y' },
          { id: 'N', name: 'N' }
        ]
      },
      {
        type: 'checkbox',
        class: 'col-12',
        id: 'pg_enable_',
        header: '',
        keyRequired: false,
        checkValidation: false,
        options: [
        ],
        populateFromApi: true,
        api: { url: 'PaymentGateway', params: {} }
      }
    ]
  },
  { type: 'hr' },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'recharge_transitional_charge',
    header: 'Gateway Handling Charges',
    placeholder: 'Enter Handling Charges',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'recharge_tax',
    header: 'Gateway Handling Tax',
    placeholder: 'Enter Handling Tax',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'ibms_tp_mobile_app_url',
    header: 'POS Terminal ID',
    placeholder: 'Enter ID',
    keyRequired: false,
    checkValidation: false
  },
  {  
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'third_party_alarm_URL',
    header: 'APP Charges Keyword',
    placeholder: 'Enter App Charges',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'no_of_tenent',
    header: 'Work Order Quantity',
    placeholder: 'Enter Quantity',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'date',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'creation_time',
    header: 'Site Created On',
    keyRequired: false,
    checkValidation: false
  },
  {
    type:'hr'
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'license',
    header: 'AIPL',
    placeholder: 'Select AIPL',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: { list:[{ id: 'Y', name: 'Enable' }, { id: 'N', name: 'Disable' },{ id: 'T', name: 'AMR(32 PORT)' },{ id: 'X', name: 'AMR(42 PORT)'}]}

  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'battery_available',
    header: 'Billing Mode',
    placeholder: 'Select Mode',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: { list:[{ id: 'N', name: 'Default' }, { id: 'S', name: 'Society' }]}
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'employee_id',
    header: 'SMS Gateway',
    placeholder: 'Select Gateway',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    populateFromApi: true,
    api: { url: 'SiteSmsService', params: {} }
    // options: { list:[{ id: 'Y', name: 'Enable' }, { id: 'N', name: 'Disable' },{ id: 'T', name: 'AMR(32 PORT)' },{ id: 'X', name: 'AMR(42 PORT)'}]}
  },
  // {
  //   type: 'auto-complete',
  //   class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
  //   id: 'recharge_mode',
  //   header: 'Payment Recharge Mode',
  //   placeholder: 'Select Mode',
  //   keyRequired: false,
  //   checkValidation: false,
  //   idSelect:true,
  //   options: { list:[{ id: 'DIRECT', name: 'Direct in resource' }, { id: 'PROCESSOR', name: 'Through processor'}]}
  // },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'pp_available',
    header: 'PP Available',
    placeholder: 'Select YES/NO',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: { list:[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]}
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'display_device',
    header: 'DG Available',
    placeholder: 'Select YES/NO',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: { list:[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]}
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'customer_id',
    header: 'Customer',
    placeholder: 'Select Customer',
    keyRequired: false,
    checkValidation: false,
    populateFromApi: true,
    idSelect:true,
    api: { url: 'Customer', params: {} }
  },
  // {  For future 
  //   type: 'auto-complete',
  //   class: 'col-3',
  //   id: 'region_id',
  //   header: 'Region',
  //   placeholder: 'Select Region',
  //   keyRequired: false,
  //   checkValidation: false,
  //   populateFromApi: true,
  //   api: { url: 'regions', params: {} }
  // },

];


export const edit_sitedetail = [
        {
          "type": "tabs",
          "active": 1,
          "tabs": [
            {
              "id": 1,
              "title": "Basic Details",
              "children": [
                        {
                            type: 'input',
                            class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                            id: 'short_code',
                            header: 'Site Code',
                            placeholder: 'Select Code',
                            keyRequired: true,
                            checkValidation: false,
                            readonly:true
                          },
                          {
                            type: 'input',
                            class: 'col-12 col-sm-6 col-md-9 col-lg-9 col-xl-9',
                            id: 'name',
                            header: 'Site Name',
                            placeholder: 'Enter Site Name',
                            keyRequired: true,
                            checkValidation: false
                          },
                          {
                            type: 'auto-complete',
                            class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                            id: 'country',
                            header: 'Country',
                            placeholder: 'Country',
                            keyRequired: true,
                            checkValidation: false,
                            populateFromApi: false,
                            showEdit: false,
                            options:[]
                          },
                          {
                            type: 'auto-complete',
                            class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                            id: 'state',
                            header: 'State',
                            placeholder: 'State',
                            keyRequired: true,
                            checkValidation: false,
                            populateFromApi: false,
                            showEdit: false,
                            options:[]
                          },
                          {
                            type: 'auto-complete',
                            class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                            id: 'city',
                            header: 'City',
                            placeholder: 'City',
                            keyRequired: true,
                            checkValidation: false,
                            populateFromApi: true,
                            showEdit: false,
                            options:[]
                          },
                          {
                            type: 'input',
                            class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                            id: 'zipcode',
                            header: 'Zip Code',
                            placeholder: 'Enter Code',
                            keyRequired: true,
                            checkValidation: false
                          },
                          {
                            type: 'textarea',
                            class: 'col-12',
                            id: 'address',
                            header: 'Address',
                            placeholder: 'Enter Full Address',
                            keyRequired: true,
                            checkValidation: false
                          },
              ]
            },
            {
              "id": 2,
              "title": "Gateway Details",
              "children": [
                            {
                                type: 'input',
                                class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                                id: 'site_group',
                                header: 'Parent Organization',
                                placeholder: 'Enter Parent Organization',
                                keyRequired: false,
                                checkValidation: false
                              },
                              {
                                type: 'input',
                                class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                                id: 'facility_name',
                                header: 'Facility Co. Name',
                                placeholder: 'Enter Co. Name',
                                keyRequired: false,
                                checkValidation: false
                              },
                              {
                                type: 'input',
                                class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                                id: 'currency',
                                header: 'Currency',
                                placeholder: 'Enter Currency',
                                keyRequired: false,
                                checkValidation: false,
                                readonly:true
                              },
                              {
                                type: 'select-dropdown',
                                class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                                id: 'application',
                                header: 'Application',
                                placeholder: 'Select Application',
                                keyRequired: true,
                                checkValidation: false,
                                populateFromApi: true,
                                showEdit:true,
                                api: { url: 'Application', params: {} }
                              },
                              {
                                type: 'select-dropdown',
                                class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                                id: 'type',
                                header: 'Type',
                                placeholder: 'Select Type',
                                keyRequired: false,
                                checkValidation: false,
                                populateFromApi: true,
                                api: { url: 'Processor', params: {} }
                              },
                              {
                                type: 'select-dropdown',
                                class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                                id: 'project_id',
                                header: 'Site Solution Type',
                                placeholder: 'Select Solution',
                                keyRequired: true,
                                checkValidation: false,
                                populateFromApi: true,
                                api: { url: 'SiteSolutionType', params: {} }
                              },
                              {
                                type: 'select-dropdown',
                                class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                                id: 'communication',
                                header: 'Communication',
                                placeholder: 'Select Communication',
                                keyRequired: true,
                                checkValidation: false,
                                populateFromApi: true,
                                api: { url: 'Communications', params: {} }
                              },
                              {
                                type: 'group',
                                header: 'Select Payment Gateways',
                                class: 'col-12 col-sm-6 col-md-9 col-lg-9 col-xl-9',
                                children: [
                                  {
                                    type: 'radio',
                                    class: 'col-12',
                                    id: 'pg_enable',
                                    header: '',
                                    keyRequired: true,
                                    checkValidation: false,
                                    options: [
                                      { id: 'Y', name: 'Yes' },
                                      { id: 'N', name: 'No' }
                                    ]
                                  },
                                  { 
                                    type: 'checkbox',
                                    class: 'col-12',
                                    id: 'pg_enable_',
                                    header: '',
                                    keyRequired: false,
                                    checkValidation: false,
                                    options: [
                                    ],
                                    populateFromApi: true,
                                    api: { url: 'PaymentGateway', params: {} }
                                  }
                                ]
                              },
              ]
            },
            {
              "id": 3,
              "title": "Charge Details",
              "children": [
                            {
                              type: 'input',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'recharge_transitional_charge',
                              header: 'Gateway Handling Charges',
                              placeholder: 'Enter Handling Charges',
                              keyRequired: false,
                              checkValidation: false
                            },
                            {
                              type: 'input',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'recharge_tax',
                              header: 'Gateway Handling Tax',
                              placeholder: 'Enter Handling Tax',
                              keyRequired: false,
                              checkValidation: false
                            },
                            {
                              type: 'input',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'ibms_tp_mobile_app_url',
                              header: 'POS Terminal ID',
                              placeholder: 'Enter ID',
                              keyRequired: false,
                              checkValidation: false
                            },
                            {  
                              type: 'input',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'third_party_alarm_URL',
                              header: 'APP Charges Keyword',
                              placeholder: 'Enter App Charges',
                              keyRequired: false,
                              checkValidation: false
                            },
                            {
                              type: 'input',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'no_of_tenent',
                              header: 'Work Order Quantity',
                              placeholder: 'Enter Quantity',
                              keyRequired: false,
                              checkValidation: false
                            },
                            {
                              type: 'date',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'creation_time',
                              header: 'Site Created On',
                              keyRequired: false,
                              checkValidation: false
                            },
              ]
            },
            {
              "id": 4,
              "title": "Charges Mode Details",
              "children": [
                            {
                              type: 'auto-complete',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'license',
                              header: 'AIPL',
                              placeholder: 'Select AIPL',
                              keyRequired: false,
                              checkValidation: false,
                              idSelect:true,
                              options: { list:[{ id: 'Y', name: 'Enable' }, { id: 'N', name: 'Disable' },{ id: 'T', name: 'AMR(32 PORT)' },{ id: 'X', name: 'AMR(42 PORT)'}]}
                            },
                            {
                              type: 'auto-complete',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'battery_available',
                              header: 'Billing Mode',
                              placeholder: 'Select Mode',
                              keyRequired: false,
                              checkValidation: false,
                              idSelect:true,
                              options: { list:[{ id: 'N', name: 'Default' }, { id: 'S', name: 'Society' }]}

                            },
                            {
                              type: 'auto-complete',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'employee_id',
                              header: 'SMS Gateway',
                              placeholder: 'Select Gateway',
                              keyRequired: false,
                              checkValidation: false,
                              populateFromApi: true,
                              idSelect:true,
                              api: { url: 'SiteSmsService', params: {} }
                            },
                            // {
                            //   type: 'auto-complete',
                            //   class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                            //   id: 'recharge_mode',
                            //   header: 'Payment Recharge Mode',
                            //   placeholder: 'Select Mode',
                            //   keyRequired: false,
                            //   checkValidation: false,
                            //   readonly:true,
                            // },
                            {
                              type: 'auto-complete',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'pp_available',
                              header: 'PP Available',
                              placeholder: 'Select YES/NO',
                              keyRequired: false,
                              checkValidation: false,
                              idSelect:true,
                              options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
                            },
                            {
                              type: 'auto-complete',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'display_device',
                              header: 'DG Available',
                              placeholder: 'Select YES/NO',
                              keyRequired: false,
                              checkValidation: false,
                                 idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
                            },
                            {
                              type: 'auto-complete',
                              class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
                              id: 'customer_id',
                              header: 'Customer',
                              placeholder: 'Select Customer',
                              keyRequired: false,
                              checkValidation: false,
                              populateFromApi: true,
                              idSelect:true,
                              api: { url: 'Customer', params: {} }
                            },
                            // {
                            //   type: 'auto-complete',
                            //   class: 'col-3',
                            //   id: 'region_id',
                            //   header: 'Region',
                            //   placeholder: 'Select Region',
                            //   keyRequired: false,
                            //   checkValidation: false,
                            //   populateFromApi: true,
                            //   api: { url: 'regions', params: {} }
                            // },
                          ]
            }
          ]
        }
];
    
export const edit_supportinfo = [
    {
    type: 'input',
    class: 'col-12',
    id: 'name',
    header: 'Site Name',
    placeholder: 'Enter Site Name',
    keyRequired: false,
    checkValidation: false,
    existingValue:''
  },
  {
    type: 'auto-complete',
    class: 'col-6',
    id: 'supervisor_name',
    header: 'Supervisor Name',
    placeholder: 'Supervisor Name',
    keyRequired: false,
    checkValidation: false,
    populateFromApi: true,
    existingValue:'',
    showEdit:true,
    api: { url: 'SupervisorList', params: {} }
  },
  {
    type: 'select-dropdown',
    class: 'col-6',
    id: 'name3',
    header: 'Engineer',
    placeholder: 'Engineer',
    keyRequired: false,
    checkValidation: false,
    populateFromApi: true,
    showEdit:true,
    api: { url: 'Engineer', params: {} }
  },
]

export const edit_features = [
  {
    type: 'input',
    class: 'col-12',
    id: 'name',
    header: 'Site Name',
    placeholder: 'Enter Site Name',
    keyRequired: true,
    checkValidation: false,
    existingValue: ''
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'reading_validator_mf',
    header: 'Reading MF Validator',
    placeholder: 'Enter Validator Number',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'absolute_consumption',
    header: 'Truncate Decimal Reading',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'date',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'live_date',
    header: 'Live Data Date',
    placeholder: 'Select Date',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'sms_enabled',
    header: 'Enable SMS Alert',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'email_enabled',
    header: 'Enable Email Alert',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'third_party_alarm_enabled',
    header: 'Third Party Alerts',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'third_party_alarm_server_ip',
    header: 'Third Party Server IP',
    placeholder: 'Enter IP',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'third_party_alarm_server_port',
    header: 'Third Party Server Port',
    placeholder: 'Enter Port Number',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: 'col-6',
    id: 'alert_email_ids',
    header: 'Alert Email-ID(s)',
    placeholder: 'Enter Email-ID(s)',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: 'col-6',
    id: 'alert_mobile_nos',
    header: 'Alert Mobile-No(s)',
    placeholder: 'Enter Mobile-No(s)',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: 'col-12',
    id: 'third_party_alarm_URL',
    header: 'Third Party URL',
    placeholder: 'Enter URL',
    keyRequired: false,
    checkValidation: false
  }
];

export const edit_amr_config = [
  {
    type: 'input',
    class: 'col-12',
    id: 'name',
    header: 'Site Name',
    placeholder: 'Enter Site Name',
    keyRequired: true,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'main_licence',
    header: 'Electricity Main License',
    placeholder: 'Enter License',
    keyRequired: false,
    checkValidation: false
  },
  // {
  //   type: 'auto-complete',
  //   class: 'col-3',
  //   id: 'fcu_quantity',
  //   header: 'KV Connection',
  //   placeholder: 'Select KV',
  //   keyRequired: false,
  //   checkValidation: false,
  //      options: { list: [{ id: '11', name: '11' }, { id: '33', name: '33' }] }
  // },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'live_streaming',
    header: 'Fixed Time Push Notification',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'reading_unit',
    header: 'Reading Unit',
    placeholder: 'Select Unit',
    keyRequired: false,
    checkValidation: false,
       options: { list: [{ id: 'KWH', name: 'KWH' }, { id: 'KVAH', name: 'KVAH' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_flat',
    header: 'No. of Flats',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_tower',
    header: 'No. of Towers',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_dg',
    header: 'No. of DG',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_transformer',
    header: 'No. of Transformers',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_meter_panel',
    header: 'Number of Meter Panel',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_comm_module',
    header: 'No. of Comm Module',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_dic',
    header: 'Number of DIC Card',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'number_of_gateway',
    header: 'No of M2M Gateway',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'grid_mode',
    header: 'Grid Mode',
    placeholder: 'Select Mode',
    keyRequired: false,
    checkValidation: false,
       options: { list: [{ id: 'Prepaid', name: 'PREPAID' }, { id: 'Postpaid', name: 'POSTPAID' }] }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'dgMode', // 🚨 not found in API, kept as-is
    header: 'DG Mode',
    placeholder: 'Select Mode',
    keyRequired: false,
    checkValidation: false,
       options: { list: [{ id: 'Prepaid', name: 'PREPAID' }, { id: 'Postpaid', name: 'POSTPAID' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'low_balance_alert',
    header: 'Low Balance Alert Amount',
    placeholder: 'Enter Low Amount',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'low_balance_d_display',
    header: 'Dashboard Low Balance',
    placeholder: 'Enter Low Balance',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'recharge_dial_no',
    header: 'Recharge Dial No.',
    placeholder: 'Enter No.',
    keyRequired: false,
    checkValidation: false
  }
];

export const edit_site_charges = [
  {
    type: 'input',
    class: 'col-12',
    id: 'name', // from API key
    header: 'Site Name',
    placeholder: 'Enter Site Name',
    keyRequired: true,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'active_cut_off',
    header: 'Active Cut off',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'happy_hh_from',
    header: 'Happy Hour From',
    placeholder: 'Select Hour',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
          list: [
            { id: '99', name: 'None' },
            { id: '0', name: '12 : 00 AM' },
            { id: '1', name: '01 : 00 AM' },
            { id: '2', name: '02 : 00 AM' },
            { id: '3', name: '03 : 00 AM' },
            { id: '4', name: '04 : 00 AM' },
            { id: '5', name: '05 : 00 AM' },
            { id: '6', name: '06 : 00 AM' },
            { id: '7', name: '07 : 00 AM' },
            { id: '8', name: '08 : 00 AM' },
            { id: '9', name: '09 : 00 AM' },
            { id: '10', name: '10 : 00 AM' },
            { id: '11', name: '11 : 00 AM' },
            { id: '12', name: '12 : 00 PM' },
            { id: '13', name: '01 : 00 PM' },
            { id: '14', name: '02 : 00 PM' },
            { id: '15', name: '03 : 00 PM' },
            { id: '16', name: '04 : 00 PM' },
            { id: '17', name: '05 : 00 PM' },
            { id: '18', name: '06 : 00 PM' },
            { id: '19', name: '07 : 00 PM' },
            { id: '20', name: '08 : 00 PM' },
            { id: '21', name: '09 : 00 PM' },
            { id: '22', name: '10 : 00 PM' },
            { id: '23', name: '11 : 00 PM' }
          ]
        }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'happy_hh_to',
    header: 'Happy Hour To',
    placeholder: 'Select Hour',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
      list: [
        { id: '99', name: 'None' },
        { id: '0', name: '12 : 00 AM' },
        { id: '1', name: '01 : 00 AM' },
        { id: '2', name: '02 : 00 AM' },
        { id: '3', name: '03 : 00 AM' },
        { id: '4', name: '04 : 00 AM' },
        { id: '5', name: '05 : 00 AM' },
        { id: '6', name: '06 : 00 AM' },
        { id: '7', name: '07 : 00 AM' },
        { id: '8', name: '08 : 00 AM' },
        { id: '9', name: '09 : 00 AM' },
        { id: '10', name: '10 : 00 AM' },
        { id: '11', name: '11 : 00 AM' },
        { id: '12', name: '12 : 00 PM' },
        { id: '13', name: '01 : 00 PM' },
        { id: '14', name: '02 : 00 PM' },
        { id: '15', name: '03 : 00 PM' },
        { id: '16', name: '04 : 00 PM' },
        { id: '17', name: '05 : 00 PM' },
        { id: '18', name: '06 : 00 PM' },
        { id: '19', name: '07 : 00 PM' },
        { id: '20', name: '08 : 00 PM' },
        { id: '21', name: '09 : 00 PM' },
        { id: '22', name: '10 : 00 PM' },
        { id: '23', name: '11 : 00 PM' }
      ]
    }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'mmc_deduction_day',
    header: 'MMC Charges Deduction Day',
    placeholder: 'Select Day',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
          list: [
            { id: '0', name: 'None' },
            { id: '1', name: '01' },
            { id: '2', name: '02' },
            { id: '3', name: '03' },
            { id: '4', name: '04' },
            { id: '5', name: '05' },
            { id: '6', name: '06' },
            { id: '7', name: '07' },
            { id: '8', name: '08' },
            { id: '9', name: '09' },
            { id: '10', name: '10' },
            { id: '11', name: '11' },
            { id: '12', name: '12' },
            { id: '13', name: '13' },
            { id: '14', name: '14' },
            { id: '15', name: '15' },
            { id: '16', name: '16' },
            { id: '17', name: '17' },
            { id: '18', name: '18' },
            { id: '19', name: '19' },
            { id: '20', name: '20' },
            { id: '21', name: '21' },
            { id: '22', name: '22' },
            { id: '23', name: '23' },
            { id: '24', name: '24' },
            { id: '25', name: '25' },
            { id: '26', name: '26' },
            { id: '27', name: '27' },
            { id: '28', name: '28' },
            { id: '99', name: 'Daily Basis' }
          ]
        }  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'mmc_deduction_hour',
    header: 'MMC Charges Deduction Time',
    placeholder: 'Select Time',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
      list: [
        { id: '99', name: 'None' },
        { id: '0', name: '12 : 00 AM' },
        { id: '1', name: '01 : 00 AM' },
        { id: '2', name: '02 : 00 AM' },
        { id: '3', name: '03 : 00 AM' },
        { id: '4', name: '04 : 00 AM' },
        { id: '5', name: '05 : 00 AM' },
        { id: '6', name: '06 : 00 AM' },
        { id: '7', name: '07 : 00 AM' },
        { id: '8', name: '08 : 00 AM' },
        { id: '9', name: '09 : 00 AM' },
        { id: '10', name: '10 : 00 AM' },
        { id: '11', name: '11 : 00 AM' },
        { id: '12', name: '12 : 00 PM' },
        { id: '13', name: '01 : 00 PM' },
        { id: '14', name: '02 : 00 PM' },
        { id: '15', name: '03 : 00 PM' },
        { id: '16', name: '04 : 00 PM' },
        { id: '17', name: '05 : 00 PM' },
        { id: '18', name: '06 : 00 PM' },
        { id: '19', name: '07 : 00 PM' },
        { id: '20', name: '08 : 00 PM' },
        { id: '21', name: '09 : 00 PM' },
        { id: '22', name: '10 : 00 PM' },
        { id: '23', name: '11 : 00 PM' }
      ]
    }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'fixed_deduction_day',
    header: 'Fixed Charges Deduction Day',
    placeholder: 'Select Day',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
          list: [
            { id: '0', name: 'None' },
            { id: '1', name: '01' },
            { id: '2', name: '02' },
            { id: '3', name: '03' },
            { id: '4', name: '04' },
            { id: '5', name: '05' },
            { id: '6', name: '06' },
            { id: '7', name: '07' },
            { id: '8', name: '08' },
            { id: '9', name: '09' },
            { id: '10', name: '10' },
            { id: '11', name: '11' },
            { id: '12', name: '12' },
            { id: '13', name: '13' },
            { id: '14', name: '14' },
            { id: '15', name: '15' },
            { id: '16', name: '16' },
            { id: '17', name: '17' },
            { id: '18', name: '18' },
            { id: '19', name: '19' },
            { id: '20', name: '20' },
            { id: '21', name: '21' },
            { id: '22', name: '22' },
            { id: '23', name: '23' },
            { id: '24', name: '24' },
            { id: '25', name: '25' },
            { id: '26', name: '26' },
            { id: '27', name: '27' },
            { id: '28', name: '28' },
            { id: '99', name: 'Daily Basis' }
          ]
        }  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'fixed_deduction_hour',
    header: 'Fixed Charges Deduction Time',
    placeholder: 'Select Time',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
      list: [
        { id: '99', name: 'None' },
        { id: '0', name: '12 : 00 AM' },
        { id: '1', name: '01 : 00 AM' },
        { id: '2', name: '02 : 00 AM' },
        { id: '3', name: '03 : 00 AM' },
        { id: '4', name: '04 : 00 AM' },
        { id: '5', name: '05 : 00 AM' },
        { id: '6', name: '06 : 00 AM' },
        { id: '7', name: '07 : 00 AM' },
        { id: '8', name: '08 : 00 AM' },
        { id: '9', name: '09 : 00 AM' },
        { id: '10', name: '10 : 00 AM' },
        { id: '11', name: '11 : 00 AM' },
        { id: '12', name: '12 : 00 PM' },
        { id: '13', name: '01 : 00 PM' },
        { id: '14', name: '02 : 00 PM' },
        { id: '15', name: '03 : 00 PM' },
        { id: '16', name: '04 : 00 PM' },
        { id: '17', name: '05 : 00 PM' },
        { id: '18', name: '06 : 00 PM' },
        { id: '19', name: '07 : 00 PM' },
        { id: '20', name: '08 : 00 PM' },
        { id: '21', name: '09 : 00 PM' },
        { id: '22', name: '10 : 00 PM' },
        { id: '23', name: '11 : 00 PM' }
      ]
    }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'CAM_deduction_day',
    header: 'CAM Charges Deduction Day',
    placeholder: 'Select Day',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
          list: [
            { id: '0', name: 'None' },
            { id: '1', name: '01' },
            { id: '2', name: '02' },
            { id: '3', name: '03' },
            { id: '4', name: '04' },
            { id: '5', name: '05' },
            { id: '6', name: '06' },
            { id: '7', name: '07' },
            { id: '8', name: '08' },
            { id: '9', name: '09' },
            { id: '10', name: '10' },
            { id: '11', name: '11' },
            { id: '12', name: '12' },
            { id: '13', name: '13' },
            { id: '14', name: '14' },
            { id: '15', name: '15' },
            { id: '16', name: '16' },
            { id: '17', name: '17' },
            { id: '18', name: '18' },
            { id: '19', name: '19' },
            { id: '20', name: '20' },
            { id: '21', name: '21' },
            { id: '22', name: '22' },
            { id: '23', name: '23' },
            { id: '24', name: '24' },
            { id: '25', name: '25' },
            { id: '26', name: '26' },
            { id: '27', name: '27' },
            { id: '28', name: '28' },
            { id: '99', name: 'Daily Basis' }
          ]
        }  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'CAM_deduction_hour',
    header: 'CAM Charges Deduction Time',
    placeholder: 'Select Time',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
      list: [
        { id: '99', name: 'None' },
        { id: '0', name: '12 : 00 AM' },
        { id: '1', name: '01 : 00 AM' },
        { id: '2', name: '02 : 00 AM' },
        { id: '3', name: '03 : 00 AM' },
        { id: '4', name: '04 : 00 AM' },
        { id: '5', name: '05 : 00 AM' },
        { id: '6', name: '06 : 00 AM' },
        { id: '7', name: '07 : 00 AM' },
        { id: '8', name: '08 : 00 AM' },
        { id: '9', name: '09 : 00 AM' },
        { id: '10', name: '10 : 00 AM' },
        { id: '11', name: '11 : 00 AM' },
        { id: '12', name: '12 : 00 PM' },
        { id: '13', name: '01 : 00 PM' },
        { id: '14', name: '02 : 00 PM' },
        { id: '15', name: '03 : 00 PM' },
        { id: '16', name: '04 : 00 PM' },
        { id: '17', name: '05 : 00 PM' },
        { id: '18', name: '06 : 00 PM' },
        { id: '19', name: '07 : 00 PM' },
        { id: '20', name: '08 : 00 PM' },
        { id: '21', name: '09 : 00 PM' },
        { id: '22', name: '10 : 00 PM' },
        { id: '23', name: '11 : 00 PM' }
      ]
    }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'CS_deduction_day', 
    header: 'CS Charges Deduction Day',
    placeholder: 'Select Day',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
          list: [
            { id: '0', name: 'None' },
            { id: '1', name: '01' },
            { id: '2', name: '02' },
            { id: '3', name: '03' },
            { id: '4', name: '04' },
            { id: '5', name: '05' },
            { id: '6', name: '06' },
            { id: '7', name: '07' },
            { id: '8', name: '08' },
            { id: '9', name: '09' },
            { id: '10', name: '10' },
            { id: '11', name: '11' },
            { id: '12', name: '12' },
            { id: '13', name: '13' },
            { id: '14', name: '14' },
            { id: '15', name: '15' },
            { id: '16', name: '16' },
            { id: '17', name: '17' },
            { id: '18', name: '18' },
            { id: '19', name: '19' },
            { id: '20', name: '20' },
            { id: '21', name: '21' },
            { id: '22', name: '22' },
            { id: '23', name: '23' },
            { id: '24', name: '24' },
            { id: '25', name: '25' },
            { id: '26', name: '26' },
            { id: '27', name: '27' },
            { id: '28', name: '28' },
            { id: '99', name: 'Daily Basis' }
          ]
        }
    },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'CS_deduction_hour',
    header: 'CS Charges Deduction Time',
    placeholder: 'Select Time',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
      list: [
        { id: '99', name: 'None' },
        { id: '0', name: '12 : 00 AM' },
        { id: '1', name: '01 : 00 AM' },
        { id: '2', name: '02 : 00 AM' },
        { id: '3', name: '03 : 00 AM' },
        { id: '4', name: '04 : 00 AM' },
        { id: '5', name: '05 : 00 AM' },
        { id: '6', name: '06 : 00 AM' },
        { id: '7', name: '07 : 00 AM' },
        { id: '8', name: '08 : 00 AM' },
        { id: '9', name: '09 : 00 AM' },
        { id: '10', name: '10 : 00 AM' },
        { id: '11', name: '11 : 00 AM' },
        { id: '12', name: '12 : 00 PM' },
        { id: '13', name: '01 : 00 PM' },
        { id: '14', name: '02 : 00 PM' },
        { id: '15', name: '03 : 00 PM' },
        { id: '16', name: '04 : 00 PM' },
        { id: '17', name: '05 : 00 PM' },
        { id: '18', name: '06 : 00 PM' },
        { id: '19', name: '07 : 00 PM' },
        { id: '20', name: '08 : 00 PM' },
        { id: '21', name: '09 : 00 PM' },
        { id: '22', name: '10 : 00 PM' },
        { id: '23', name: '11 : 00 PM' }
      ]
    }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'other_deduction_day',
    header: 'Other Charges Deduction Day',
    placeholder: 'Select Day',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
          list: [
            { id: '0', name: 'None' },
            { id: '1', name: '01' },
            { id: '2', name: '02' },
            { id: '3', name: '03' },
            { id: '4', name: '04' },
            { id: '5', name: '05' },
            { id: '6', name: '06' },
            { id: '7', name: '07' },
            { id: '8', name: '08' },
            { id: '9', name: '09' },
            { id: '10', name: '10' },
            { id: '11', name: '11' },
            { id: '12', name: '12' },
            { id: '13', name: '13' },
            { id: '14', name: '14' },
            { id: '15', name: '15' },
            { id: '16', name: '16' },
            { id: '17', name: '17' },
            { id: '18', name: '18' },
            { id: '19', name: '19' },
            { id: '20', name: '20' },
            { id: '21', name: '21' },
            { id: '22', name: '22' },
            { id: '23', name: '23' },
            { id: '24', name: '24' },
            { id: '25', name: '25' },
            { id: '26', name: '26' },
            { id: '27', name: '27' },
            { id: '28', name: '28' },
            { id: '99', name: 'Daily Basis' }
          ]
        }  
      },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'other_deduction_hour',
    header: 'Other Charges Deduction Time',
    placeholder: 'Select Time',
    keyRequired: false,
    checkValidation: false,
    idSelect:true,
    options: {
      list: [
        { id: '99', name: 'None' },
        { id: '0', name: '12 : 00 AM' },
        { id: '1', name: '01 : 00 AM' },
        { id: '2', name: '02 : 00 AM' },
        { id: '3', name: '03 : 00 AM' },
        { id: '4', name: '04 : 00 AM' },
        { id: '5', name: '05 : 00 AM' },
        { id: '6', name: '06 : 00 AM' },
        { id: '7', name: '07 : 00 AM' },
        { id: '8', name: '08 : 00 AM' },
        { id: '9', name: '09 : 00 AM' },
        { id: '10', name: '10 : 00 AM' },
        { id: '11', name: '11 : 00 AM' },
        { id: '12', name: '12 : 00 PM' },
        { id: '13', name: '01 : 00 PM' },
        { id: '14', name: '02 : 00 PM' },
        { id: '15', name: '03 : 00 PM' },
        { id: '16', name: '04 : 00 PM' },
        { id: '17', name: '05 : 00 PM' },
        { id: '18', name: '06 : 00 PM' },
        { id: '19', name: '07 : 00 PM' },
        { id: '20', name: '08 : 00 PM' },
        { id: '21', name: '09 : 00 PM' },
        { id: '22', name: '10 : 00 PM' },
        { id: '23', name: '11 : 00 PM' }
      ]
    }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'dg_mmc_st_charges',
    header: 'GST on DG MMC Charges (in %)',
    placeholder: 'Enter Charges',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'dg_fixed_st_charges',
    header: 'GST on DG Fixed charges (in %)',
    placeholder: 'Enter Charges',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'CAM_st_charges',
    header: 'GST on CAM Charges (in %)',
    placeholder: 'Enter Charges',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'CS_st_charges',
    header: 'GST on CS Charges (in %)',
    placeholder: 'Enter Charges',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'other_st_charges',
    header: 'GST on Other Charges (in %)',
    placeholder: 'Enter Charges',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'ST_NO',
    header: 'GST NO.',
    placeholder: 'Enter GST No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'PAN_NO',
    header: 'PAN NO.',
    placeholder: 'Enter PAN No.',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'CIN_NO',
    header: 'CIN NO.',
    placeholder: 'Enter CIN No.',
    keyRequired: false,
    checkValidation: false
  }
];

export const edit_appliances = [
  {
    type: 'input',
    class: 'col-12',
    id: 'name',
    header: 'Site Name',
    placeholder: 'Enter Site Name',
    keyRequired: true,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'dg_available',
    header: 'DG',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'dg_quantity',
    header: '#DG',
    placeholder: 'Enter DG Count',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'grid_available',
    header: 'Grid',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'battery_available',
    header: 'Battery Bank',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'battery_quantity',
    header: '#Battery Bank',
    placeholder: 'Enter Count',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'pp_available',
    header: 'Power Plant',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'pp_quantity',
    header: '#Power Plant',
    placeholder: 'Enter Count',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'aircon_available',
    header: 'MD Enable Check',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'aircon_quantity',
    header: 'Air-Con',
    placeholder: 'Enter Details',
    keyRequired: false,
    checkValidation: false
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'access_control_available',
    header: 'Access Control',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'auto-complete',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'rf_reader_available',
    header: 'RF Reader',
    placeholder: 'Yes/No',
    keyRequired: false,
    checkValidation: false,
       idSelect:true,
       options: { list: [{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }] }
  },
  {
    type: 'input',
    class: "col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3",
    id: 'aircon_capacity',
    header: 'Unit Rate',
    placeholder: 'Enter Rate',
    keyRequired: false,
    checkValidation: false
  }
];